import React from 'react'
import { createBehavior, createResource } from '@designable/core'
import { DnFC, DroppableWidget } from '@designable/react'
import { createBaseSchema } from '../Field'
import FormilyChildBox from './ChildBox'

export const ChildBox: DnFC<any> = FormilyChildBox

ChildBox.Behavior = createBehavior({
  name: 'ChildBox',
  // extends: ['Field'],
  selector: (node) => node.props['x-component'] === 'ChildBox',
  designerProps: {
    // droppable: false,
    // propsSchema: createBaseSchema(),
  },
  designerLocales: {
    'zh-CN': {
      title: '子页面占位容器',
    }
  },
})

ChildBox.Resource = createResource({
  icon: 'BoxSource',
  elements: [
    {
      componentName: 'Field',
      props: {
        type: 'void',
        'x-component': 'ChildBox',
      },
    },
  ],
})
